import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex w-100 justify-content-end mb-4 pr-6" }

import InfoModal from "@/components/Common/InfoModal.vue"
import { computed } from 'vue'
import i18n from "@/lang/i18n"


export default /*@__PURE__*/_defineComponent({
  __name: 'NotClearableInforModal',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit
const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(InfoModal, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValue).value = $event)),
    modalWidth: "35%",
    title: _unref(i18n).global.t('common.confirmationModal.title')
  }, {
    text: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.roleAssignment.modal.notClearable.row1')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.roleAssignment.modal.notClearable.row2')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_btn, {
          class: "close-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (modelValue.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.closeBtn')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})